import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';
import { BREAKPOINTS, MOBILE_BREAKPOINT } from '@src/styles/config';

export const StyledEarningsManagementContainer = styled('div')`
  .earnings-management-card {
    margin: 16px 4px;
    min-height: 101vh;
    .earnings-management-banner {
      padding: 0 24px;
    }
    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      padding: 20px;
      margin: 8px 0;
      display: flex;
      gap: 24px;
    }

    @media only screen and (max-width: ${BREAKPOINTS.MXS}px) {
      padding: 0;
    }
  }

  .earnings-management-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 1135px;
    width: 100%;
    margin: 0 auto;
  }

  .earnings-management-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-top: 24px;
    .btn-loading {
      color: ${COLOR.navyBlue};
    }
  }
`;

export const StyledEarningsHeader = styled('div')`
  display: flex;
  padding: 24px 24px 0 24px;
  gap: 16px;
`;

export const StyledRequestDialogContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px;
  max-width: 432px;

  .character-container {
    margin: 16px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    .character {
      font-weight: 700;
      font-size: 24px;
      line-height: 32px;
      letter-spacing: -0.4px;
      vertical-align: middle;
      color: ${COLOR.darkGray};
    }
    .unit {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.4px;
      vertical-align: middle;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .character-container {
      margin: 0;
    }
  }
`;

export const StyledRequestDialogNote = styled('div')`
  min-height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
  background-color: ${(props) => props.backgroundColor || '#007aff14'};
  box-sizing: border-box;

  .warning-wrapper {
    background-color: #007aff14 !important;
  }

  .note-icon {
    color: #007aff;
    width: 20px;
    height: 20px;
  }

  .note-icon-warning {
    color: ${COLOR.alert};
    width: 20px;
    height: 20px;
  }

  .note-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    vertical-align: middle;
    color: ${COLOR.darkGray};
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .note-text {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: -0.4px;
      vertical-align: middle;
    }
  }
`;

export const StyledRequestDialogAction = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  .dialog-actions-button {
    width: 100%;
    padding: 8px 16px;
  }

  .circular-progress {
    color: ${COLOR.white};
    margin-top: 5px;
  }
`;
